import React from 'react';
import {X} from 'lucide-react';

const DocumentViewer = ({isOpen, onClose, fileUrl, fileType}) => {
    if (!isOpen) return null;

    // בניית URL לצפייה במסמך בהתאם לסוג הקובץ
    const getViewerUrl = () => {
        if (fileType === 'application/pdf') {
            return fileUrl;
        } else {
            // שימוש ב-Google Docs Viewer עבור מסמכי Word
            return `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
        }
    };

    return (
        <div className="fixed inset-0 z-50 overflow-hidden">
            <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose}/>

            <div className="relative w-full h-full p-4">
                <div className="absolute top-4 right-4 z-10">
                    <button
                        onClick={onClose}
                        className="p-2 bg-white rounded-full hover:bg-gray-100 transition-colors"
                    >
                        <X className="w-6 h-6"/>
                    </button>
                </div>

                <iframe
                    src={getViewerUrl()}
                    className="w-full h-full rounded-lg bg-white"
                    title="Document Viewer"
                />
            </div>
        </div>
    );
};

export default DocumentViewer;